import Alpine from 'alpinejs';
import moment from 'moment';

window.Alpine = Alpine;
window.moment = moment;

Alpine.start();
